// Jira-Workflow-Helpers — identisch zur V1-Logik.
//   NEW → OPEN → AWAITING REFINEMENT → BACKLOG → READY → IN PROGRESS →
//   CODEREVIEW → IN INTEGRATION → AWAITING TEST → IN TEST → RESOLVED → CLOSED
// Quer: REJECTED, ABORTED, DONE

export const REFINED_STATUSES = new Set([
  'ready','in progress','codereview','in integration','awaiting test','in test',
  'resolved','closed','aborted','rejected','done',
]);

// Terminale Status: was als „geschlossen" zählt für Ist-Aufwand,
// Trend-Zählung, Modell-Aggregation, Duplikat-Scan usw. Bewusst OHNE „done"
// — das Feld wird in dieser JIRA-Instanz nicht aktiv genutzt.
export const DONE_STATUSES = new Set(['closed','resolved','aborted']);

export const REFINED_PLUS = new Set([
  'backlog','ready','in progress','codereview','in integration','awaiting test','in test',
]);

export const STATUS_ORDER = [
  'New','Open','Awaiting Refinement','Backlog','Ready',
  'In Progress','Codereview','In Integration',
  'Awaiting Test','In Test',
  'Resolved','Closed','Done',
  'Rejected','Aborted',
] as const;

export const MANDATORY_STATUS: readonly string[] = [
  'New','Open','Awaiting Refinement','Backlog','Ready',
  'In Progress','Codereview','In Integration',
  'Awaiting Test','In Test',
  'Resolved','Closed',
  'Rejected','Aborted',
];

export function statusKey(s: string | undefined | null): string {
  return (s || '').toLowerCase().trim();
}
export function isRefined(s: string): boolean { return REFINED_STATUSES.has(statusKey(s)); }
export function isDone(s: string): boolean    { return DONE_STATUSES.has(statusKey(s)); }
export function slug(s: string): string       { return statusKey(s).replace(/[^a-z0-9]+/g, '-'); }

export type StatusCategory =
  | 'new' | 'open' | 'refine' | 'backlog' | 'ready' | 'progress' | 'review'
  | 'integ' | 'await-test' | 'test' | 'resolved' | 'closed' | 'done'
  | 'aborted' | 'rejected';

export function statusCategory(status: string | undefined | null): StatusCategory {
  const s = statusKey(status);
  if (s === 'new') return 'new';
  if (s === 'open') return 'open';
  if (s === 'awaiting refinement' || s === 'refinement') return 'refine';
  if (s === 'backlog') return 'backlog';
  if (s === 'ready') return 'ready';
  if (s === 'in progress') return 'progress';
  if (s === 'codereview' || s === 'code review') return 'review';
  if (s === 'in integration') return 'integ';
  if (s === 'awaiting test') return 'await-test';
  if (s === 'in test') return 'test';
  if (s === 'resolved') return 'resolved';
  if (s === 'closed') return 'closed';
  if (s === 'done') return 'done';
  if (s === 'aborted') return 'aborted';
  if (s === 'rejected') return 'rejected';
  return 'new';
}

export function statusSortIdx(s: string): number {
  const k = statusKey(s);
  const idx = STATUS_ORDER.findIndex(x => statusKey(x) === k);
  return idx < 0 ? 999 : idx;
}
